module.exports = __webpack_public_path__ + "img/01-min.a6235431.jpg";